// extracted by mini-css-extract-plugin
module.exports = {"root":"Video_root__jmt_7","info":"Video_info__I9P_K","duration":"Video_duration__TT6cG","subtitle":"Video_subtitle__px9w9","title":"Video_title__6LF_K"};